<template>
	<div>
		<ejs-dialog ref='loadding' cssClass='h-system-loadding' width='340px' height='121px' v-bind:visible='false' isModal=true>
			<div class="h-system-outer"></div>
			<div class="h-system-upText"><div>{{upText}}</div><div class="h-system-downText">{{downText}}</div></div>

		</ejs-dialog>
	</div>
</template>

<script>
export default {
	name: 'Loadding',
	data() {
		return {
			upText: '',
			downText: '',
      status: 1,
		}
	},
	methods: {
		show() {
      this.status = 1;
			this.$refs.loadding.show();
		},
		hide() {
      this.status = 0;
      this.$refs.loadding.hide();
		}
	}
}
</script>

